const GET_CINEMAS_REQUEST = "GET_CINEMAS_REQUEST";
const GET_CINEMAS_SUCCESS = "GET_CINEMAS_SUCCESS";
const GET_CINEMAS_FAILURE = "GET_CINEMAS_FAILURE";

export {
    GET_CINEMAS_REQUEST,
    GET_CINEMAS_FAILURE,
    GET_CINEMAS_SUCCESS
}